import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_PROVIDERS_ROUTE_LOADING = 'GET_PROVIDERS_ROUTE_LOADING';
export const GET_PROVIDERS_ROUTE_SUCCESS = 'GET_PROVIDERS_ROUTE_SUCCESS';
export const GET_PROVIDERS_ROUTE_REJECT = 'GET_PROVIDERS_ROUTE_REJECT';

//* ACTIONS ------------------------------------------------
export const getProvidersRouteLoading = () => ({ type: GET_PROVIDERS_ROUTE_LOADING });
export const getProvidersRouteSuccess = (payload) => ({ type: GET_PROVIDERS_ROUTE_SUCCESS, payload });
export const getProvidersRouteReject = (payload) => ({ type: GET_PROVIDERS_ROUTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getProvidersRouteRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/ProvidersBillingTracking/web/GetProvidersBillingTrackingRoutes`, options);
};

